import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Customer } from '../api/api_pb';
import RelativeTime from '../components/RelativeTime';
import { useGlobalContext } from '../GlobalContext';
import SMSDeliveryLogs from '../components/SMSDeliveryLogs';

const CustomerDetail: React.FC = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const navigate = useNavigate();
    const { customers } = useGlobalContext();
    const [customer, setCustomer] = useState<Customer | null>(null);

    useEffect(() => {
        if (uuid && customers) {
            // Find the specific customer by uuid
            const foundCustomer = customers.find(c => c.uuid === uuid);
            if (foundCustomer) {
                setCustomer(foundCustomer);
            }
        }
    }, [uuid, customers]);

    const handleShowLeases = () => {
        if (customer) {
            navigate(`/show-lease/${customer.uuid}`);
        }
    };

    const handleBack = () => {
        navigate('/customers');
    };

    if (!customer) {
        return (
            <div className="p-4">
                <button 
                    onClick={handleBack}
                    className="mb-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                    Back to Customers
                </button>
                <div className="text-center">Customer not found</div>
            </div>
        );
    }

    return (
        <div className="p-4">
            <div className="mb-4">
                <button 
                    onClick={handleBack}
                    className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                    Back to Customers
                </button>
            </div>

            <div className="bg-white shadow rounded-lg p-6 mb-6">
                <h2 className="text-2xl font-bold mb-4">Customer Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="font-semibold">Mobile Number:</label>
                        <p>{customer.mobileNumber}</p>
                    </div>
                    <div>
                        <label className="font-semibold">Customer ID:</label>
                        <p className="text-sm text-gray-600">{customer.uuid}</p>
                    </div>
                    <div>
                        <label className="font-semibold">Created At:</label>
                        <p>
                            {customer.createdAt ? (
                                <div className="text-sm">
                                    <div><RelativeTime timestamp={customer.createdAt} /></div>
                                </div>
                            ) : 'N/A'}
                        </p>
                    </div>
                </div>
                <div className="mt-4">
                    <button
                        onClick={handleShowLeases}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                        Show Leases
                    </button>
                </div>
            </div>

            <div className="bg-white shadow rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4">SMS Delivery History</h3>
                <p className="text-sm text-gray-600 mb-4">SMS messages sent to this customer with delivery status</p>
                <SMSDeliveryLogs customerId={customer.uuid} />
            </div>
        </div>
    );
};

export default CustomerDetail;